<!-- src/views/AuthAnimation.vue -->
<template>
  <div class="auth-animation-container bg-auth-animation-img">
    <div class="animation-wrapper">
      <!-- 簡單的加載動畫 -->
      <img
        src="@/assets/img/images/MSU_logo_horizontal_white.svg"
        class="msulogo"
      />
      <div class="loading-spinner"></div>
      <h1 class="text-white">{{ statusMessage }}</h1>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useI18n } from "vue-i18n";

const router = useRouter();
const route = useRoute();
const { t } = useI18n();
const statusMessage = ref(t("checking-auth-status"));

onMounted(() => {
  // 獲取要跳轉的目標路徑
  const targetPath = route.query.redirect || "/msu/home";

  // 檢查用戶是否已登入
  const token = localStorage.getItem("token");

  // 設置延遲，讓動畫有時間顯示
  setTimeout(() => {
    if (token) {
      // 用戶已登入，顯示成功訊息
      statusMessage.value = t("auth-success-loading-page");

      // 顯示成功訊息後再跳轉
      setTimeout(() => {
        console.log("跳轉到:", targetPath);
        // 路徑處理
        if (targetPath.startsWith("/") && !targetPath.startsWith("/v2/")) {
          router.replace("/v2" + targetPath);
        } else {
          router.replace(targetPath);
        }
      }, 800);
    } else {
      // 用戶未登入，顯示提示訊息
      statusMessage.value = t("auth-need-login-first");

      // 跳轉到登入頁
      setTimeout(() => {
        router.replace({
          path: "/login",
          query: { redirect: targetPath },
        });
      }, 1200);
    }
  }, 1500);
});
</script>

<style scoped>
.auth-animation-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  background-color: #f9f9f9;
  overflow: hidden; /* 防止內容溢出造成滾動條 */
  position: relative; /* 讓絕對定位的元素可以相對於它定位 */
}

.bg-auth-animation-img {
  background-image: url(@/assets/img/background/bg-achievement.png);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover; /* 這是關鍵屬性，讓背景圖片總是覆蓋整個容器 */
  background-attachment: fixed; /* 可選：固定背景，這樣在手機滾動時背景不會移動 */
}

.animation-wrapper {
  text-align: center;
  z-index: 2; /* 確保內容顯示在背景上方 */
  padding: 20px;
  background-color: rgba(249, 249, 249, 0.366); /* 半透明背景，讓文字更易讀 */
  border-radius: 10px;
}

.loading-spinner {
  width: 60px;
  height: 60px;
  border: 6px solid #f3f3f3;
  border-top: 6px solid #3498db;
  border-radius: 50%;
  margin: 0 auto 20px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

h2 {
  font-size: 22px;
  color: #333;
  margin-top: 15px;
}

/* 響應式設計：在小屏幕設備上調整樣式 */
@media screen and (max-width: 768px) {
  .animation-wrapper {
    width: 90%; /* 在小屏幕上佔據更多寬度 */
    max-width: 400px; /* 但也不要太寬 */
  }

  h2 {
    font-size: 18px; /* 縮小字體大小 */
  }
}
</style>
